export default __webpack_public_path__ + "static/sp-link-1071bef479e3a61392d336f27eab7682.png";